import { voucher } from '@huggg/back-bar';
import initialStateLoader from '../initialState';
import { UPDATE as UPDATE_HUGGG, fetchHuggg, fetchRedeemedProduct } from './huggg';
import { VOUCHER_GENERATED } from './redeem';
import AnalyticsService from 'services/AnalyticsService';

const analytics = new AnalyticsService();
const GENERATE = 'huggg/voucher/GENERATE';
const GENERATE_SUCCESS = 'huggg/voucher/GENERATE_SUCCESS';
const GENERATE_FAILURE = 'huggg/voucher/GENERATE_FAILURE';
const CLEAR_ERROR = 'huggg/voucher/CLEAR_ERROR';

export const types = {
  CLEAR_ERROR,
  GENERATE,
  GENERATE_SUCCESS,
  GENERATE_FAILURE
};

const { voucher: initialState } = initialStateLoader();

/* Reducer - Default Export
========================================================================== */
const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case GENERATE:
      return { ...state, isGenerating: true };

    case GENERATE_FAILURE:
      return { ...state, error: payload.error, isGenerating: false };

    case GENERATE_SUCCESS:
      return {
        ...state,
        error: null,
        isGenerating: false
      };

    case CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default reducer;

/* Action Creators
========================================================================== */
export const clearError = () => dispatch => dispatch({ type: CLEAR_ERROR });

/* Side Effects
========================================================================== */
export const generate = (
  hugggID,
  segmentID,
  integrationID,
  data = undefined,
  action = 'claim'
) => (dispatch, getState) => {
  const state = getState();

  if (state.voucher?.isGenerating) {
    return Promise.resolve();
  }

  const { huggg } = state.huggg;

  dispatch({ type: GENERATE });

  return voucher
    .generate(hugggID, segmentID, integrationID, data, action)
    .then(responseData => {
      analytics.passiveCompleteHugggVoucherRedeen({
        hugggId: huggg.id,
        brandId: huggg.brand_id,
        brandName: huggg.brand_name,
        productId: huggg.purchase.id,
        productName: huggg.purchase.label
      });

      dispatch({
        type: UPDATE_HUGGG,
        payload: {
          vouchers: responseData.vouchers,
          redeemedSegment: responseData.segment
        }
      });
      dispatch(fetchRedeemedProduct());
      dispatch({ type: VOUCHER_GENERATED });
      dispatch({ type: GENERATE_SUCCESS });

      dispatch(fetchHuggg(huggg.shortcode));

      // Return voucher data so component can check if redirect is needed
      return responseData;
    })
    .catch(err => {
      if (process.env.NODE_ENV === 'development' && !window.Cypress) {
        console.error(err);
      }

      dispatch({
        type: GENERATE_FAILURE,
        payload: { error: err?.response?.data ?? err }
      });
    });
};

/* Selectors
========================================================================== */
export const getError = state => state.voucher.error;
export const getIsGenerating = state => state.voucher.isGenerating;

export const actions = {
  clearError,
  getError,
  getIsGenerating,
  generate
};
